import { PinchZoom } from './components/PinchZoom';
import { Swiper } from './components/Swiper';

export { PinchZoom, Swiper };
